import { render, staticRenderFns } from "./userPassword.vue?vue&type=template&id=0bb83cc6"
import script from "./userPassword.vue?vue&type=script&lang=js"
export * from "./userPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports